import styled from 'styled-components';

export const PanelSectionContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex: 1;

  > * {
    flex: 1;
    margin: 10px;
    text-align: justify;
  }

  .bold {
    font-weight: bold;
  }
`;
